import React from "react";

export default ({netPresent, simplePayback, irr, discountedPayback}) => {

    return <table className="indicators">
        <tbody>
        <tr>
            <td className="indicator-label">
                <div className="indicator">Net Present Value (20 years)</div>
                <div className="help">
                    <p>Discounted cash flow reflecting the time value of money.
                        It represents the sum of the present values of the individual cash flows of a project; its
                        calculation depends on the selected discount rate as well as on the length of the calculation
                        period; for this calculator the period of 20 years is chosen.
                    </p>
                    <p>
                        The general rule for NPV is:
                        <ul>
                            <li>
                                NPV &gt; 0 – project favourable for investment
                            </li>
                            <li>
                                NPV &lt; 0 – project not favourable for investment
                            </li>
                        </ul>
                    </p>
                </div>
            </td>
            <td className="indicator-value">{netPresent}</td>
        </tr>
        <tr>
            <td className="indicator-label">

                <div className="indicator">Internal Rate Ratio [%]</div>
                <div className="help">
                    <p>
                        Rate of return used in capital budgeting to measure the profitability of
                        investment. It represents the discount rate at which the NPV of an investments becomes zero.
                    </p>
                    <p>
                        In other words – it is the interest rate which will make the total of the future cash flows
                        exactly
                        equal to the original investment.
                    </p>
                </div>
            </td>
            <td className="indicator-value">{irr}</td>
        </tr>
        <tr>
            <td className="indicator-label">
                <div className="indicator">Simple Payback Period [years]</div>
                <div className="help">The time in years for a project cumulative annual savings to equal its upfront
                    costs
                </div>
            </td>
            <td className="indicator-value">{simplePayback}</td>
        </tr>
        <tr>
            <td className="indicator-label">
                <div className="indicator">Discounted Payback Period [years]</div>
                <div className="help">Based on the same rationale as Simple Payback Period; the difference is
                    represented by the fact the net cash flows are discounted in order to account for the time value of
                    money
                </div>
            </td>
            <td className="indicator-value">{discountedPayback}</td>
        </tr>

        </tbody>
    </table>
}
